import { render } from "./HelpImageViewerMobile.vue?vue&type=template&id=e6d8a5f8&scoped=true&ts=true"
import script from "./HelpImageViewerMobile.vue?vue&type=script&lang=ts"
export * from "./HelpImageViewerMobile.vue?vue&type=script&lang=ts"

import "./HelpImageViewerMobile.vue?vue&type=style&index=0&id=e6d8a5f8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d8a5f8"]])

export default __exports__